import { render } from "./FormsList.vue?vue&type=template&id=58337a8c&scoped=true"
import script from "./FormsList.vue?vue&type=script&lang=js"
export * from "./FormsList.vue?vue&type=script&lang=js"

import "./FormsList.vue?vue&type=style&index=0&id=58337a8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58337a8c"]])

export default __exports__